import moment from "moment";
import { get } from "lodash";

export function getGridDateTemplate(rowData, column) {
  const dateString = get(rowData, column.field);
  if (!dateString) return "";
  return moment(dateString).format("DD/MM/YYYY HH:mm:ss");
}

export function printLabels(id, small = false) {
  const prtContent = document.getElementById(id);

  const WinPrint = window.open(
    "",
    "",
    "left=0,top=0,width=800,height=900,toolbar=1,menubar=1,scrollbars=0,status=0"
  );

  const css = `
  * {
    box-sizing: border-box;
  }
  
  html {
    height: 100%;
  }
  
  body {
    font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 14px;
    color: #333333;
    background-color: #edf0f5;
    margin: 0;
    padding: 0;
    min-height: 100%;
  }
  body .menuitem-badge {
    margin-top: 3px;
    font-size: 10px;
    float: right;
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    color: #ffffff;
    background-color: #007be5;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
  }
  
  a {
    text-decoration: none;
  }

  .label-barcodes {
    background-color: #ffffff;
    margin: 0;
    page-break-inside: avoid; 
  }
    .label-barcodes div {
      text-align: center; 
  }
  
  @media print {
    @page {
      size: auto;
      /* auto is the initial value */
      margin: 0mm;
      /* this affects the margin in the printer settings */ }
    html {
      background-color: #ffffff;
      margin: 0 !important;
      height: auto !important;
      page-break-after: avoid !important;
      /* this affects the margin on the html before sending to printer */ }
    .labels-container {
      background-color: #ffffff;
      width: 62mm;
      height: 25mm !important;
      border: none;
      margin: 0 !important;
      page-break-after: avoid !important;
      /* margin you want for the content */ }
      .labels-container .label-barcodes {
        width: 62mm;
        height: 25mm;
        page-break-after: always; } }
  `;

  if (WinPrint) {
    WinPrint.document.write(
      `<html><head><style type="text/css">${css}</style></head><body class='labels-container${
      small ? "-small" : ""
      }'>${prtContent.innerHTML}</body></html>`
    );

    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  }
}


export const it = {
  firstDayOfWeek: 1,
  dayNames: ["Domenica", "Lunedí", "Martedí", "Mercoledí", "Giovedí", "Venerdí", "Sabato"],
  dayNamesShort: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  dayNamesMin: ["D", "L", "M", "ME", "G", "V", "S"],
  monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
  monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Sep", "Ott", "Nov", "Dic"],
  today: 'Oggi',
  clear: 'Cancella',
  dateFormat: 'dd/mm/yy',
  weekHeader: 'Sett'
};
